import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';

function GamesPreview_() {

    const { url } = useParams();
    const name = window.location.search.replace('?', '');
    const searchParams = new URLSearchParams(window.location.search.replace('?', ''));
    const gameName = searchParams.get('name');

    const [state, setState] = useState([]);
    console.log(name, "========name");
    console.log(url, "========url");


    // const getGameListFunc = async () => {
    //     const api_res = await axios.get("https://pub.gamezop.com/v3/games?id=9632&lang=en")
    //     const New_Data = api_res?.data?.games?.filter((item) => item?.name?.en?.toLowerCase().replace(/\s+/g, "-") === name);
    //     setState(New_Data[0] || null);
    // }

    // useEffect(() => {
    //     getGameListFunc();
    // }, [name]);

    return (
        <div>
            <Helmet>
                {/* <!-- Title and Description --> */}
                <title>{`Play ${gameName} Online | gameszone – Free Online Games`}</title>
                <meta name="description" content={`${gameName} | gameszone`} />

                {/* <!-- Keywords for SEO --> */}
                <meta name="keywords" content={`play ${gameName} online, free ${gameName} game, ${gameName} game preview, online games, TheGameZone`} />

                {/* // <meta property="og:title" content={`Play ${state?.name?.en} Online | gameszone – Free Game Preview`} />
                // <meta property="og:description" content={`Discover ${state?.name?.en} on gameszone! ${state?.description?.en} Enjoy this game and many more for free online.`} />
                // <meta property="og:url" content={`https://thegamezone.fun/game/${state?.slug}`} />
                // <meta property="og:type" content="article" />
                // <meta property="og:image" content={`https://thegamezone.fun/assets/images/games/${state?.image}`} />
                // <meta property="og:locale" content="en_US" />

                // <meta name="twitter:card" content="summary_large_image" />
                // <meta name="twitter:title" content={`Play ${state?.name?.en} Online | TheGameZone – Free Game Preview`} />
                // <meta name="twitter:description" content={`${state?.description?.en} | TheGameZone`} />
                // <meta name="twitter:image" content={`https://thegamezone.fun/assets/images/games/${state?.image}`} />

                // <meta name="robots" content="index, follow" />
                // <link rel="canonical" href={`https://thegamezone.fun/game/${state?.slug}`} />  */}
            </Helmet>

            <iframe src={name} title={'games'} allow="autoplay" className='w-screen h-screen' />

        </div>
    )
}

export default GamesPreview_